import React from "react"

import UserManagementContent from "../components/users/UserManagementContent"
import DashboardLayout from "../layouts/DashboardLayout"

const UserManagement: React.FC = () => {
  return (
    <DashboardLayout>
      <div className="bg-white p-6 rounded-lg shadow-sm">
        <UserManagementContent />
      </div>
    </DashboardLayout>
  )
}

export default UserManagement
